<div class="rail-head">
  <div class="rail-title">
    <h2><mat-icon>shield</mat-icon> {{ 'Roles' | translate }}</h2>
  </div>
  <div class="rail-search">
    <mat-icon class="rail-search-icon">search</mat-icon>
    <input type="search" [attr.placeholder]="'Search roles' | translate"
      [attr.aria-label]="'Search roles' | translate"
      [ngModel]="searchTerm" (ngModelChange)="onSearchChange($event)" />
    </div>
  </div>

  <div class="rail-list" role="listbox" [attr.aria-label]="'Roles in this tenant' | translate">
    @for (item of filteredItems; track trackByKey($index, item)) {
      <button type="button" class="role-item" role="option"
        [class.dirty]="item.isDirty"
        [attr.aria-current]="item.key === selectedKey"
        [attr.aria-selected]="item.key === selectedKey"
        (click)="onSelect(item)">
        <div class="role-item-top">
          <span class="role-item-name">{{ item.name }}</span>
          @if (item.isSystem) {
            <span class="status-badge status-badge--system">
              <mat-icon>lock</mat-icon> {{ 'System' | translate }}
            </span>
          }
          @if (item.isDirty) {
            <span class="status-badge status-badge--unsaved">{{ 'Unsaved' | translate }}</span>
          }
          @if (item.requireMfa) {
            <span class="status-badge status-badge--mfa-required" [matTooltip]="'Requires MFA' | translate">
              <mat-icon>verified_user</mat-icon> {{ 'MFA' | translate }}
            </span>
          }
        </div>
        @if (item.description) {
          <div class="role-item-desc">{{ item.description }}</div>
        }
        <div class="role-item-meta">
          <span>
            <mat-icon>grid_view</mat-icon>
            {{ item.grantedCount }} / {{ item.totalCount }} {{ 'objects' | translate }}
          </span>
        </div>
      </button>
    }

    @if (!filteredItems.length) {
      <div class="rail-empty">
        {{ 'No roles match your search.' | translate }}
      </div>
    }
  </div>
